import React from 'react'
import { Link } from 'react-router-dom'
import SearchIcon from '@material-ui/icons/Search'

import Loader from '../common/components/notifications/Loader'
import RestrictedComponent from '../lib/components/form/RestrictedComponent'
import { makeStyles, TextField } from '@material-ui/core'

const useStyles = makeStyles(() => ({
  heading: {
    display: 'flex',
    justifyContent: 'space-between',
  },
}))

class PreferenceController extends React.Component {
  constructor(props) {
    super(props)
    this.state = this.props.store()
    this.state.search = ''
    this.handleSearchChange = this.handleSearchChange.bind(this)
  }

  componentWillMount() {
    var self = this
    this.removeListener = this.props.store(function onChange(data) {
      self.setState(data)
    })
    this.props.actions.get({})
    // console.log(this.props);
  }

  componentWillUnmount() {
    this.removeListener()
  }

  handleSearchChange(search) {
    this.setState({ search })
  }

  render() {
    if (this.state.preferences.isResolving) return <Loader message='Fetching' />
    var {
      Manager,
      linkTo,
      permissionCheck,
      actions,
      credentials,
    } = this.props
    return (
      <div>
        <Heading
          onChangeSearch={this.handleSearchChange}
          searchValue={this.state.search}
          linkTo={linkTo}
          permissionCheck={permissionCheck}
        />
        <Manager
          search={this.state.search}
          preferences={this.state.preferences.data}
          credentials={credentials}
          actions={actions}
        />
      </div>
    )
  }
}

const Heading = (props) => {
  const { onChangeSearch, searchValue, linkTo, permissionCheck } = props
  const classes = useStyles()
  return (
    <div className='callout'>
      <div className={classes.heading}>
        <Search onChange={onChangeSearch} value={searchValue} />
        <RestrictedComponent permissionCheck={permissionCheck}>
          <Link to={linkTo} className='btn btn-primary'>
            <i className='fa fa-plus' /> Create New Preference
          </Link>
        </RestrictedComponent>
      </div>
    </div>
  )
}

const Search = (props) => {
  const { onChange, value } = props
  return (
    <div>
      <TextField
        placeholder='Search Preferences'
        size='small'
        InputProps={{
          style: { fontSize: '12px', backgroundColor: 'white' },
          endAdornment: <SearchIcon />,
        }}
        variant='outlined'
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  )
}

export default PreferenceController
